<template>
<!-- :style="{'background':'url(' + nullPageOne + ') no-repeat'}" -->
  <div class="container" @touchmove.prevent>
    <van-image :src="nullPageOne" style="width:100%;max-height:100vh"></van-image>
  </div>
</template>

<script>
export default {
  data(){
    return {
      nullPageOne:require("@/assets/imgs/nullPage/nullPageOne.png"),
    }
  },
  created(){
    
    this.getNullPageImg()
  },
  methods:{
    getNullPageImg(){
      this.Api({
        url:"api/getTwentyeightPicture",
        method: 'GET',
      }).then(res => {
        if(res.message == "success"){
          this.nullPageOne = res.data.url
        }
        // if(this.nullPageOne == undefined || this.nullPageOne == null || this.nullPageOne == ''){
        //   this.nullPageOne = require("@/assets/imgs/nullPage/nullPageOne.png")
        // }
      })
    }
  }
}
</script>

<style scoped>
.container {
	width: 100%;
	height: 100vh;
  background-color: #ee7129;
  /* background-size:100% 100% !important; */
/* background-attachment:fixed !important; */
}
</style>
